export default "__VITE_ASSET__D0VyJV62__"